import { WORKFLOW_ELEMENT_TYPES } from './workflowElementProperty.constants';

export const WF_PROPERTY_DATA_TYPE = {
  NUMBER: 'NUMBER',
  TEXT: 'TEXT',
  COLOR: 'COLOR',
  DATE: 'DATE',
  URL: 'URL',
  BOOLEAN: 'BOOLEAN',
  BINARY: 'BINARY',
};

export const WF_PROPERTY_TYPE_ID_TO_CODE = {
  PROP_NUMBER: WF_PROPERTY_DATA_TYPE.NUMBER,
  PROP_TEXT: WF_PROPERTY_DATA_TYPE.TEXT,
  PROP_COLOR: WF_PROPERTY_DATA_TYPE.COLOR,
  PROP_DATE: WF_PROPERTY_DATA_TYPE.DATE,
  PROP_URL: WF_PROPERTY_DATA_TYPE.URL,
  PROP_BOOL: WF_PROPERTY_DATA_TYPE.BOOLEAN,
  PROP_BINARY: WF_PROPERTY_DATA_TYPE.BINARY,
};

export const WF_PROPERTY_CONTROL_KIND = {
  [WF_PROPERTY_DATA_TYPE.NUMBER]: 'number',
  [WF_PROPERTY_DATA_TYPE.TEXT]: 'text',
  [WF_PROPERTY_DATA_TYPE.COLOR]: 'color',
  [WF_PROPERTY_DATA_TYPE.DATE]: 'date',
  [WF_PROPERTY_DATA_TYPE.URL]: 'url',
  [WF_PROPERTY_DATA_TYPE.BOOLEAN]: 'boolean',
  [WF_PROPERTY_DATA_TYPE.BINARY]: 'binary',
};

export const WF_IMAGE_SOURCE_MODE = {
  UPLOAD: 'upload',
  URL: 'url',
};

export const WF_IMAGE_SOURCE_MODE_OPTIONS = [
  { label: 'Upload', value: WF_IMAGE_SOURCE_MODE.UPLOAD },
  { label: 'URL', value: WF_IMAGE_SOURCE_MODE.URL },
];

export const WF_ELEMENT_PROPERTY_OTHER_GROUP = 'Other';

export const WF_ELEMENT_EDITOR_DRAWER_Z_INDEX = 11111;
export const WF_ELEMENT_EDITOR_POPUP_Z_INDEX = 11200;

export const WORKFLOW_ELEMENT_ASSOC_PROPERTY_PAYLOAD_KEYS = {
  [WORKFLOW_ELEMENT_TYPES.SCREEN]: 'screen_properties',
  [WORKFLOW_ELEMENT_TYPES.SECTION]: 'section_properties',
  [WORKFLOW_ELEMENT_TYPES.FIELD]: 'field_properties',
  [WORKFLOW_ELEMENT_TYPES.WIDGET]: 'field_properties',
};

export const WORKFLOW_ELEMENT_UI_PROPERTY_MAP = {
  [WORKFLOW_ELEMENT_TYPES.SCREEN]: {
    background_type: { group: 'Background', css: { type: 'bgMode' } },
    background_color: { group: 'Background', css: { type: 'bgColor' } },
    background_gradient: {
      group: 'Background',
      placeholder: 'linear-gradient(135deg, #0c4e8d, #1278fc)',
      css: { type: 'bgGradient' },
    },
    background_image: { group: 'Background', upload: 'image', css: { type: 'bgImage' } },
    content_padding: { group: 'Layout', unit: 'px', css: { type: 'style', prop: 'padding', unit: 'px' } },
    text_color: { group: 'Typography', css: { type: 'style', prop: 'color' } },
    font_size: {
      group: 'Typography',
      unit: 'px',
      css: { type: 'var', name: '--wf-el-screen-title-font-size', unit: 'px' },
    },
    font_family: { group: 'Typography', css: { type: 'style', prop: 'fontFamily' } },
  },

  [WORKFLOW_ELEMENT_TYPES.SECTION]: {
    background_color: { group: 'Background', css: { type: 'style', prop: 'backgroundColor' } },
    border_color: { group: 'Border', css: { type: 'style', prop: 'borderColor' } },
    border_width: { group: 'Border', unit: 'px', css: { type: 'style', prop: 'borderWidth', unit: 'px' } },
    border_style: { group: 'Border', css: { type: 'style', prop: 'borderStyle' } },
    border_radius: { group: 'Border', unit: 'px', css: { type: 'style', prop: 'borderRadius', unit: 'px' } },
    padding: { group: 'Layout', unit: 'px', css: { type: 'style', prop: 'padding', unit: 'px' } },
    margin: { group: 'Layout', unit: 'px', css: { type: 'style', prop: 'margin', unit: 'px' } },
    drop_shadow: { group: 'Effects', css: { type: 'shadow' } },
    title_color: { group: 'Typography', css: { type: 'var', name: '--wf-el-section-title-color' } },
  },

  [WORKFLOW_ELEMENT_TYPES.FIELD]: {
    field_look: { group: 'Appearance', css: { type: 'look' } },
    background_color: { group: 'Appearance', css: { type: 'var', name: '--wf-el-field-bg' } },
    border_color: { group: 'Border', css: { type: 'var', name: '--wf-el-field-border-color' } },
    border_width: {
      group: 'Border',
      unit: 'px',
      css: { type: 'var', name: '--wf-el-field-border-width', unit: 'px' },
    },
    border_radius: {
      group: 'Border',
      unit: 'px',
      css: { type: 'var', name: '--wf-el-field-radius', unit: 'px' },
    },
    placeholder_color: { group: 'Typography', css: { type: 'var', name: '--wf-el-field-placeholder' } },
    font_size: {
      group: 'Typography',
      unit: 'px',
      css: { type: 'var', name: '--wf-el-field-font-size', unit: 'px' },
    },
    font_color: { group: 'Typography', css: { type: 'var', name: '--wf-el-field-font-color' } },
    font_weight: { group: 'Typography', css: { type: 'var', name: '--wf-el-field-font-weight' } },
    label_color: { group: 'Typography', css: { type: 'var', name: '--wf-el-field-label-color' } },
    label_font_size: {
      group: 'Typography',
      unit: 'px',
      css: { type: 'var', name: '--wf-el-field-label-font-size', unit: 'px' },
    },
    label_font_weight: { group: 'Typography', css: { type: 'var', name: '--wf-el-field-label-font-weight' } },
  },
};

export const getElementUiPropertyMap = (elementType) =>
  WORKFLOW_ELEMENT_UI_PROPERTY_MAP[elementType] || {};
